export default __webpack_public_path__ + "static/bodySectionBg-76c70d030c8942b1ae5c3dd484c948d1.png";